export default __webpack_public_path__ + "static/cruiselines-vv-activities-7-feadca9d9a748cd416fa5fcb3b609710.jpg";